<template>
  <g fill="none">
    <path d="M.062.062h19.875v19.875H.062V.062z" />
    <path
      d="M10 3.212c2.211 0 2.474.008 3.347.048 2.245.102 3.292 1.167 3.395 3.394.04.873.047 1.135.047 3.346 0 2.213-.008 2.474-.047 3.347-.103 2.225-1.149 3.292-3.396 3.395-.872.04-1.134.048-3.346.048-2.211 0-2.474-.008-3.346-.048-2.25-.103-3.293-1.173-3.395-3.396-.04-.872-.048-1.134-.048-3.346 0-2.211.008-2.473.048-3.346.103-2.227 1.149-3.293 3.395-3.395.873-.039 1.135-.047 3.346-.047zm0-1.493c-2.25 0-2.53.01-3.414.05-3.007.138-4.678 1.806-4.817 4.817-.042.883-.05 1.165-.05 3.414s.01 2.532.05 3.414c.138 3.008 1.806 4.68 4.817 4.818.883.04 1.165.05 3.414.05s2.532-.01 3.414-.05c3.006-.139 4.68-1.807 4.817-4.818.041-.882.05-1.165.05-3.414s-.01-2.53-.05-3.414c-.134-3.005-1.805-4.678-4.816-4.817-.883-.042-1.166-.05-3.415-.05zm0 4.029a4.253 4.253 0 10.001 8.505A4.253 4.253 0 0010 5.748zm0 7.012a2.76 2.76 0 110-5.52 2.76 2.76 0 010 5.52zm4.42-8.173a.993.993 0 100 1.986.993.993 0 000-1.986z"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
